import React, { useEffect, useRef } from 'react';
import get from 'lodash/get';
import at from 'lodash/at';
import { withTheme } from 'styled-components';
import { ReactSelect } from 'crux';
import { connect } from 'react-redux';
import { updateAnswersArray } from '../redux/actions';
import { getCurrentQuestionSet } from '../redux/selector/questions';
import { getLabelProps, getWidth, getTooltipProps, getDataSelectorOptions, getMappedOptions, getCSSVariables } from './utils';

function DataSelector({
  question,
  theme,
  updateAnswer,
  dataSelector,
  lastFocusedElementId,
}) {

  const {
		question_id: questionId,
		question_description: questionText,
    response_options: responseOptions,
    selector_options: selectorOptions,
		hint_title: tooltipTitle,
		hint_text: tooltipBody,
		hint_html: tooltipHTML,
    tooltip,
    validations,
    is_hidden: isHidden,
  } = question;

  const {
		pageId,
		config: {
			theme: {
				pageOverrides,
				components,
				global: { colorScheme,reactSelect },
			},
		},
  } = theme;
  const cssVariables = getCSSVariables(theme);
  const _font = at(cssVariables, ['pageOverride.font', 'global.font']);
  if (reactSelect) {
    reactSelect.selectLabel.font = _font?.[0]?.['selectOption-label'] || _font?.[1]?.['selectOption-label']
    reactSelect.placeholder.font = _font?.[0]?.['selectOption-placeholder'] || _font?.[1]?.['selectOption-placeholder']
  }
  const reactSlectThemeConfiguration = reactSelect ? {
		...reactSelect,
	} : null;
  // Tab Navigation
	const inputRef = useRef();
	useEffect(() => {
	const shouldFocus = lastFocusedElementId === questionId
	if (inputRef && inputRef.current && shouldFocus) {
		if (typeof inputRef.current.focus === 'function') {
		    inputRef.current.focus();
		  }
	  }
	}, []);
  
  const { floatingLabel, labelPosition, labelIsHTML } = getLabelProps(
		'selectOption',
		components,
		pageId,
		pageOverrides,
  );
  
  const tooltipProps = getTooltipProps(tooltipTitle, tooltipBody, tooltipHTML || tooltip);

  const customSelectPlaceholder = get(validations, 'custom_placeholder.value', '');
  
  const mappedOptions = getMappedOptions(responseOptions, selectorOptions);
  let dataSelectorOptions = [...mappedOptions];
  if(Array.isArray(dataSelector.get(questionId))){
    dataSelectorOptions = [...dataSelectorOptions, ...dataSelector.get(questionId)]
  }
  
  const handleSelectOption = ( response ) => {
    const options = dataSelectorOptions[response.id];
    options.forEach((option, index) => updateAnswer(option, selectorOptions[index].id));
  }
  if(isHidden) return null;
  return (
    <ReactSelect
      key={ questionId }
      id={ questionId }
      inputRef={ inputRef }
      floatingLabel={ floatingLabel }
      labelPosition={ labelPosition }
      labelText={ questionText }
      labelIsHTML={ labelIsHTML }
      placeholder="Please select an option"
      customSelectPlaceholder={ customSelectPlaceholder }
      options={ getDataSelectorOptions(dataSelectorOptions) }
      color={ colorScheme }
      defaultSelected=''
      handleSelect={ (response) => {
        handleSelectOption(response);
      } }
      type='D'
      value = 'Select...'
      isControlled
      width={ getWidth('selectOption', pageId, pageOverrides) }
      isFilterable
			themeConfiguration={ reactSlectThemeConfiguration }
      { ...tooltipProps }
    />
  )
};

const mapStateToProps = (state, props) => {
  const lastFocusedElementId = get(state, 'questions.lastFocusedElementId', '');
  const currentQuestionSet = getCurrentQuestionSet(state, props);
  const { dataSelector } = currentQuestionSet;
  return { dataSelector, lastFocusedElementId };
}
const mapDispatchToProps = (dispatch, props) => {
  const auditRequired = get(props, 'question.audit_required', false);
	return {
		updateAnswer: (option, id) => {
       dispatch(
				updateAnswersArray({
					questionId: id,
					response: option.response.value,
					questionResponse: option.response.value,
					sectionIndex: props.sectionIndex,
					preventReflexiveCall: false,
          propQuestion: props.question,
          isControlledInput: true,
          auditRequired,
				}),
			);
		 },
	};
};

export default withTheme(
	connect(mapStateToProps, mapDispatchToProps)(DataSelector),
);
